export default "__VITE_ASSET__Bk22npE$__"